var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d2-container',[_c('d2-page-cover',{attrs:{"title":"基础组件库","sub-title":"SuntrayAdmin 集成由饿了么出品的 ElementUI"}},[_c('img',{attrs:{"src":require("./image/icon.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }